import { useContext, useEffect, useState } from "react"
import MissionList from "../missionList/MissionList"
import "./leftbar.css"
//import axios from "axios"
import { AuthContext } from "../../context/AuthContext"

export default function Leftbar({ socketio, selectedMission, setSelectedMission, isMissionDragging, setMissionDragging, missions, setmissions }) {
  //const [missions,setMissions] = useState([])
  const {user} = useContext(AuthContext)

  const NothingClickHandler = async (e) => {
    e.preventDefault();
    setSelectedMission(null);
  }

  /*const fetchMissions = async () => {
    try {
      const res = await axios.get("/api/missions/");
      setMissions(res.data.sort((p1,p2) => {
        return new Date(p2.createdAt) - new Date(p1.createdAt)
      }))
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    fetchMissions();
    socketio.on("newMission", fetchMissions);
  }, [])*/

  return (
    <div className="leftbar">
      <div className="leftbarWrapper">
        <div className="leftbarTop">
          <div className="missionPoolList">
            Mission Pool
            {missions.map((p) => (
              <MissionList key={p._id} mission={p} selectedMission={selectedMission} setSelectedMission={setSelectedMission} isMissionDragging={isMissionDragging}
                setMissionDragging={setMissionDragging} />
            ))}
          </div>
        </div>
        <hr className="leftbarHr"/>
        <div className="leftbarBottom" onClick={NothingClickHandler}>
          <span>Leftbar Bottom
          Gemeinden Mission Tree List</span>
        </div>
      </div>
    </div>
  )
}
